export default __webpack_public_path__ + "static/Mobile-white-580e57688dd33d23ce07dbd1ed1af431.svg";